import React from 'react'
import ReactDOM from 'react-dom/client'
import '@agion/ui/styles.css'
import App from './App'
import './styles/globals.css'
import './core/infra_i18n'
import { initTelemetry } from '@/core/infra_telemetry'

initTelemetry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
